import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import IconCard from 'Common/Cards/IconCard.jsx';
import SettingForm from '../components/SettingForm';
import { updateData, load } from 'Actions/setting';
import { pageTitleDecorator } from 'Decorators';
import Header from 'Components/Header/Header';

@connect(
    store => ({
        settings: store.settingsList.data,
        filter: store.settingsList.filter,
    }),
    dispatch => ({
        load: filter => dispatch(load(filter)),
        updateData: data => dispatch(updateData(data)),
    })
)
@pageTitleDecorator('settings_signatures')
export default class SettingsGeneral extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        settings: PropTypes.array,
        filter: PropTypes.object,
        updateData: PropTypes.func.isRequired,
        load: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const { load, filter } = this.props;
        load(filter);
    }

    getInitialValues() {
        const { settings } = this.props;
        return settings.reduce((result, setting) => {
            result[setting.alias] = setting.value;
            return result;
        }, {});
    }

    render() {
        const { settings, updateData } = this.props;
        if (Object.keys(settings).length === 0) return null;

        return (
            <div>
                <Header title="settings.tab.general" />
                <IconCard
                    content={
                        <SettingForm
                            onSubmit={ updateData }
                            initialValues={ this.getInitialValues() }
                        />
                    }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/containers/SettingsGeneral.jsx